"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEventsEndpoints = createEventsEndpoints;
/**
 * Etkinliğin kendisi: organizatör yönetimi, public sayfa ve bilet türleri.
 */
function createEventsEndpoints(client) {
    return {
        events: {
            /** `idempotencyKey`: aynı anahtarla yinelenen istek ilk taslağı döner (C12). */
            create: (input, idempotencyKey) => client.call('/events', 'post', {
                body: input,
                header: idempotencyKey ? { 'idempotency-key': idempotencyKey } : undefined,
            }),
            mine: () => client.call('/events/mine', 'get', {}),
            /** Kurum üyeliğiyle görebildiklerim, görüntüleyici dahil (tur V2). Salt okunur. */
            mineViewable: () => client.call('/events/mine/viewable', 'get', {}),
            /** Ana sayfa bölüm 7 uyarı sinyalleri (Story 20.2) — yalnız çağıranın yönettikleri. */
            mineWarnings: () => client.call('/events/mine/warnings', 'get', {}),
            discover: (query) => client.call('/events/discover', 'get', { query: query }),
            get: (idOrSlug) => client.call('/events/{idOrSlug}', 'get', { path: { idOrSlug } }),
            update: (id, input) => client.call('/events/{id}', 'patch', { path: { id }, body: input }),
            publish: (id) => client.call('/events/{id}/publish', 'post', { path: { id } }),
            changeAccessMode: (id, input) => client.call('/events/{id}/access-mode', 'patch', { path: { id }, body: input }),
            cancel: (id) => client.call('/events/{id}/cancel', 'post', { path: { id } }),
            remove: (id) => client.call('/events/{id}', 'delete', { path: { id } }),
        },
        publicEvents: {
            get: (slug) => client.call('/public/events/{slug}', 'get', { path: { slug } }),
            /**
             * Anonim keşif (Blok 8-3). Keşif bir büyüme/SEO yüzeyidir; giriş
             * gerektirmez. `invite_only` sunucu sorgusunda HİÇ dönmez.
             */
            discover: (query) => client.call('/public/events/discover', 'get', { query: query }),
            sitemap: () => client.call('/public/events/sitemap', 'get', {}),
        },
        tickets: {
            list: (eventId) => client.call('/events/{eventId}/tickets', 'get', { path: { eventId } }),
            create: (eventId, input) => client.call('/events/{eventId}/tickets', 'post', { path: { eventId }, body: input }),
            update: (eventId, ticketId, input) => client.call('/events/{eventId}/tickets/{ticketId}', 'patch', {
                path: { eventId, ticketId },
                body: input,
            }),
            remove: (eventId, ticketId) => client.call('/events/{eventId}/tickets/{ticketId}', 'delete', {
                path: { eventId, ticketId },
            }),
        },
    };
}
//# sourceMappingURL=events.js.map